import { render, staticRenderFns } from "./SobatCategory.vue?vue&type=template&id=7906db44&"
import script from "./SobatCategory.vue?vue&type=script&lang=js&"
export * from "./SobatCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports